import requestAxios from '@/utils/request'

export function getListTermApi (params) {
  return requestAxios.get('enter-score/term', {params})
}



// WEBPACK FOOTER //
// ./src/api/enter-score/term.js